export const getCopyMessage = (name?: string) => {
  if (name) return `${name} copied to clipboard`;
  else return "Copied to clipboard";
};
